export default __webpack_public_path__ + "static/media/p37.54fe8b9b.jpg";